import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import { businessDashboardService } from '../../../services/dashboard';

/** onChange(applicationId | null) */
const ApplicationSelector = ({ value, onChange, businessName }) => {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    businessDashboardService
      .getApplications(1, 100)
      .then((res) => setApps(res.data.applications))
      .catch(() => setApps([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap', mb: 3 }}>
      <Box>
        <Typography variant="caption" color="text.secondary">
          Business
        </Typography>
        <Typography variant="subtitle1" fontWeight={600}>
          {businessName || '—'}
        </Typography>
      </Box>
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id="app-selector-label">Application</InputLabel>
        <Select
          labelId="app-selector-label"
          label="Application"
          value={value || ''}
          disabled={loading}
          onChange={(e) => onChange(e.target.value || null)}
        >
          <MenuItem value="">All Applications</MenuItem>
          {apps.map((app) => (
            <MenuItem key={app.applicationId} value={app.applicationId}>
              {app.appName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ApplicationSelector;
